import { ChatbotIcon } from "./ChatbotIcon"
import "./../css/aiassistant.css"
import { TypingIndicator } from "./ChatForm"

interface ChatMessageProps {
    chat: {
        role: string;
        text: string;
        type?: string;
        link?: string;
        dateTime?: string,
    };
}

export const ChatMessage = ({ chat }: ChatMessageProps) => {
    const isBot = chat.role === "model"
    if (chat.type === 'typing') {
        return (
          <div className="message bot-message">
            <ChatbotIcon />
            <TypingIndicator />
          </div>
        )
      }
    return (
        <div className={`message ${isBot ? 'bot' : 'user'}-message`}>
            {isBot && <ChatbotIcon /> }
            <p className="message-text">{chat.text}</p>
            
            { chat?.type === "TRIAL_USER" && chat?.link && 
            <div>
                <a href={chat?.link} className="button-link">Packages</a>
            </div>
            }
        </div>

    )
}